import { baseApi } from "../baseApi";

export const gateEntryApiNew = baseApi.injectEndpoints({
    endpoints: (builder) => ({
    getPurchaseOrderList: builder.mutation({
      query: (body) => ({
        url: '/api/method/stackerbee_mobile_wms.wms.react_api.get_purchase_order_list',
        method: 'POST',
        body,
      }),
    }),
      createGateEntry: builder.mutation({
      query: (body) => ({
        url: '/api/method/stackerbee_mobile_wms.wms.react_api.create_gate_entry',
        method: 'POST',
        body,
      }),
    }),
    updateGateEntry: builder.mutation({
      query: (body) => ({
        url: '/api/method/stackerbee_mobile_wms.wms.react_api.update_gate_entry',
        method: 'POST',
        body,
      }),
    }),
     submitGateEntry: builder.mutation({
      query: (body) => ({
        url: '/api/method/stackerbee_mobile_wms.wms.api.submit_gate_entry',
        method: 'POST',
        body,
      }),
    }),
     getGateEntryList: builder.mutation({
      query: (body) => ({
        url: '/api/method/stackerbee_mobile_wms.wms.react_api.get_gate_entry_list',
        method: 'POST',
        body,
      }),
    }),
    getVehicleList: builder.mutation({
      query: (body) => ({
        url: '/api/method/frappe.desk.reportview.get',
        method: 'POST',
        body,
      }),
    }),
    uploadFile: builder.mutation({
      query: (formData) => ({
        url: '/api/method/upload_file',
        method: 'POST',
        body: formData,
      }),
    }),
    getGateEntryById: builder.query({
  query: (id) => ({
    url: `/api/method/frappe.client.get?doctype=Gate Entry&name=${encodeURIComponent(id)}`,
    method: 'GET',
  }),
}),
  }),
});

export const { useGetPurchaseOrderListMutation,
  useCreateGateEntryMutation,
  useUpdateGateEntryMutation,
  useSubmitGateEntryMutation,
  useGetGateEntryListMutation,
  useGetVehicleListMutation,
  useUploadFileMutation,
  useGetGateEntryByIdQuery } = gateEntryApiNew;
